import React from 'react'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux';
import { downloadEventLogFile } from '../api/eventLogsFileapi';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs/plugin/utc';
import dayjsPluginTimezone from "dayjs/plugin/timezone";

dayjs.extend(dayjsPluginUTC);
dayjs.extend(dayjsPluginTimezone);

const columns = [
    { id: 'serial_number', label: 'Serial Number'},
    { id: 'controllername', label: 'Controller'},
    { id: 'created_at', label: 'Date Added' },
    { id: 'actions', label: 'Actions'}
];


const EventsLogHistory = ({logsInfo,searchLabel}) => {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleRedirect =(rowId,fileName) => {
        dispatch(downloadEventLogFile(rowId,fileName));
    };


    return (
        <Box>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                    {columns.map((column) => (
                        <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        >
                         { column.id  === 'serial_number' ? searchLabel : column.label }
                        </TableCell>
                    ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logsInfo?.length > 0 ?  logsInfo?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                        return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                            {columns.map((column) => {
                            const value = row[column.id];
                            return (
                                <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number'
                                ? column.format(value)
                                : column.id === 'actions' ?
                                <>
                                <Stack spacing={2} direction="row">
                                    <Tooltip title="Download">
                                        <DownloadIcon 
                                            onClick={(e) => handleRedirect(row['id'],row['file_name'])}
                                            sx={{cursor:'pointer'}}
                                        />
                                    </Tooltip>
                                </Stack>
                                </>
                                : column.id === 'serial_number' ?  searchLabel === 'Controller Serial Number' ? value : row?.genset_serial_number  :  column.id === 'created_at' ? dayjs(row['created_at']).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss") : value}
                                </TableCell>
                            );
                            })}
                        </TableRow>
                        );
                    }): <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                </TableBody>
                </Table>
            </TableContainer>
            { logsInfo?.length > 0 ?  
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={logsInfo?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            : <></>}
            </Paper>
        </Box>
    )
}

export default EventsLogHistory